'use client';

import { c as _c } from "react/compiler-runtime";
import { type PostFeedInput } from '@shared/all/validators';
import useLocalPreference from '@shared/utils/hooks/useLocalPreference';
import useNavigator from '@shared/utils/hooks/useNavigator';
import usePostsShared from '@shared/utils/hooks/usePosts';
import useSocket from '@shared/utils/hooks/useSocket';
import useUser from '@shared/utils/hooks/useUser';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { client } from '../../utils/trpc';
import DataMode from './DataMode';
import MediaSearchMode from './MediaSearchMode';
import PostMode from './PostMode';
import SortByFactiiiMode from './SortByFactiiiMode';
type Props = {
  params: PostFeedInput;
  manualLoading?: boolean;
  hideEndReachedMessage?: boolean;
  uniqueId?: string;
  isFullLength: boolean;
  disableLink: boolean;
  disableTracking?: boolean;
};
const Posts = props => {
  const $ = _c(34);
  const {
    navigatorState,
    setLogoClicked
  } = useNavigator();
  const {
    updatedLocalPreference,
    localPreferenceState
  } = useLocalPreference();
  const {
    currentUser
  } = useUser();
  const queryClient = useQueryClient();
  const {
    queryKey,
    appendReply,
    updateReplies,
    updateVote
  } = usePostsShared(client, props.uniqueId);
  const {
    onRepliesCount,
    onNewReply,
    onVoteCount
  } = useSocket();
  let t0;
  if ($[0] !== appendReply || $[1] !== onNewReply || $[2] !== onRepliesCount || $[3] !== onVoteCount || $[4] !== updateReplies || $[5] !== updateVote) {
    t0 = () => {
      const cleanupRepliesCount = onRepliesCount((repliesCount, postId) => {
        updateReplies(repliesCount, postId);
      });
      const cleanupNewReply = onNewReply(reply => {
        appendReply(reply);
      });
      const cleanupVoteCount = onVoteCount((totalVoteCount, postId_0) => {
        updateVote(totalVoteCount, postId_0);
      });
      return () => {
        cleanupRepliesCount();
        cleanupNewReply();
        cleanupVoteCount();
      };
    };
    $[0] = appendReply;
    $[1] = onNewReply;
    $[2] = onRepliesCount;
    $[3] = onVoteCount;
    $[4] = updateReplies;
    $[5] = updateVote;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] !== appendReply || $[8] !== updateReplies || $[9] !== updateVote) {
    t1 = [appendReply, updateReplies, updateVote];
    $[7] = appendReply;
    $[8] = updateReplies;
    $[9] = updateVote;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  useEffect(t0, t1);
  let t2;
  if ($[11] !== currentUser.isAuthenticated || $[12] !== updatedLocalPreference) {
    t2 = () => {
      if (currentUser.isAuthenticated === false) {
        updatedLocalPreference({
          postModeType: "explore"
        });
      }
    };
    $[11] = currentUser.isAuthenticated;
    $[12] = updatedLocalPreference;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== currentUser.isAuthenticated) {
    t3 = [currentUser.isAuthenticated];
    $[14] = currentUser.isAuthenticated;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  useEffect(t2, t3);
  let t4;
  if ($[16] !== navigatorState.logoClicked || $[17] !== queryClient || $[18] !== queryKey || $[19] !== setLogoClicked) {
    t4 = () => {
      if (navigatorState.logoClicked) {
        queryClient.resetQueries({
          queryKey
        });
        queryClient.resetQueries({
          queryKey: ["RelatedFactiiiCountGroups"]
        });
        setLogoClicked(false);
      }
    };
    $[16] = navigatorState.logoClicked;
    $[17] = queryClient;
    $[18] = queryKey;
    $[19] = setLogoClicked;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== navigatorState.logoClicked || $[22] !== queryKey) {
    t5 = [navigatorState.logoClicked, queryKey];
    $[21] = navigatorState.logoClicked;
    $[22] = queryKey;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  useEffect(t4, t5);
  const isSearch = props.params.source === "search";
  let t6;
  if ($[24] !== isSearch || $[25] !== localPreferenceState || $[26] !== props.disableLink || $[27] !== props.disableTracking || $[28] !== props.hideEndReachedMessage || $[29] !== props.isFullLength || $[30] !== props.manualLoading || $[31] !== props.params || $[32] !== props.uniqueId) {
    t6 = <section className="bg-background-primary">{!isSearch && localPreferenceState.displayMode === "mediaSearch" && localPreferenceState.mediaSearch ? <MediaSearchMode params={props.params} uniqueId={props.uniqueId} /> : !isSearch && localPreferenceState.postFilterType && localPreferenceState.displayMode === "data" ? <DataMode params={props.params} uniqueId={props.uniqueId} /> : !isSearch && localPreferenceState.displayMode === "sortByFactiii" ? <SortByFactiiiMode params={props.params} uniqueId={props.uniqueId} /> : <PostMode params={props.params} isFullLength={props.isFullLength} disableLink={props.disableLink} disableTracking={props.disableTracking} manualLoading={props.manualLoading} hideEndReachedMessage={props.hideEndReachedMessage} uniqueId={props.uniqueId} />}</section>;
    $[24] = isSearch;
    $[25] = localPreferenceState;
    $[26] = props.disableLink;
    $[27] = props.disableTracking;
    $[28] = props.hideEndReachedMessage;
    $[29] = props.isFullLength;
    $[30] = props.manualLoading;
    $[31] = props.params;
    $[32] = props.uniqueId;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  return t6;
};
export default Posts;